export type MarketPlaceEmailTemplate = {
  id: string;
  createdAt: string | null;
  updatedAt: string | null;
  deletedAt: string | null;
  createdBy: string | null;
  updatedBy: string | null;

  body: string;
  subject: string;
  language: string;
};

export type MarketPlaceSummary = {
  id: string;
  createdAt: string | null;
  updatedAt: string | null;
  deletedAt: string | null;
  createdBy: string | null;
  updatedBy: string | null;
  summary: string;
  opportunities: string[];
};

export type MarketPlaceWhatsappMessage = {
  id: string;
  createdAt: string | null;
  updatedAt: string | null;
  deletedAt: string | null;
  createdBy: string | null;
  updatedBy: string | null;

  message: string;
  imageUrl: string | null;
  language: string;
};

export enum HoldingPeriodEnum {
  "1-2days" = "1-2days",
  "3-5days" = "3-5days",
  "5-10days" = "5-10days",
}

export enum RiskLevelEnum {
  Low = "Low",
  Medium = "Medium",
  High = "High",
}

export type MarketPlaceTradeAdvise = {
  id: string;
  createdAt: string | null;
  updatedAt: string | null;
  deletedAt: string | null;
  createdBy: string | null;
  updatedBy: string | null;
  action: string;
  symbol: string;
  language: string;
  balance: string;
  equity: string;
  riskLevel: RiskLevelEnum;
  holdingPeriod: HoldingPeriodEnum;
  confidence: string;
  summary: string;
  marketBias: string;
  type: string;
  takeProfit: string;
  stopLoss: string;
  riskNote: string;
  volume: string;
  comment: string | null;
  priceOrder: string | null;
  extraData: Record<string, any> | null;
};

export type MarketPlaceTraderAnalysis = {
  id: string;
  createdAt: string | null;
  updatedAt: string | null;
  deletedAt: string | null;
  createdBy: string | null;
  updatedBy: string | null;
  symbol: string;
  analysis?: string[];
  language?: string;
  imageUrl?: string;
  extraData?: Record<string, any>;
};
